<template>
    <div class="loading" v-show="$store.getters.showLoader">
        <div class='inside-loader'>
            <img src="./../../assets/gifs/rocket.gif" id="gif-loader">
            <span id="git-text">
                {{ gifText }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                gifText: 'Carregando...',
                gifTexts: [
                    'Carregando...',
                    'Lendo registros...',
                    'Organizando os dados...',
                    'Verificando acertividade...',
                    'Montando estrutura de dados...',
                    'Realizando OCR...',
                    'Enquadrando documento...',
                    'Lendo o documento...',
                    'Gravando registros...',
                    'Formatando dados...'
                ],
                textIntervalReference: null
            }
        },
        mounted: function(){
            const self = this;
        },
        watch: {
            '$store.getters.showLoader': function(newVal){
                const self = this
                if(!newVal){
                    clearInterval(self.textIntervalReference);
                } else {
                    self.textIntervalReference = setInterval(function(){
                        self.gifText = self.gifTexts[Math.floor(Math.random() * 10)];
                    }, 1500)
                }
            }
        }
    }
</script>


<style>

    /* Absolute Center Spinner */
    .loading {
        position: fixed;
        z-index: 999999;

        content: '';
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(62, 110, 214, 0.8);
    }

    .inside-loader {
        margin-top: 60%;
        opacity: 1;
        width: 100%;
        text-align: center;
        height: 100%;
    }

    #gif-loader {
        width: 40%;
    }

    #git-text {
        color: white;
        display: block;
        font-weight: 800;
        font-size: 28px;
        margin-top: 20px; 
    }
    


</style>



// WEBPACK FOOTER //
// src/components/layout/Loader.vue